module.exports = "/_next/static/images/credical-e5dbb328aa580f12eb06c6343ae04519.png";